module.exports = {
        srcSet: __webpack_public_path__ + "static/media/boxes-346.adb7ee91.webp"+" 346w",
        images: [{path: __webpack_public_path__ + "static/media/boxes-346.adb7ee91.webp",width: 346,height: 291}],
        src: __webpack_public_path__ + "static/media/boxes-346.adb7ee91.webp",
        toString: function(){return __webpack_public_path__ + "static/media/boxes-346.adb7ee91.webp"},
        
        width: 346,
        height: 291
      }